import { render, staticRenderFns } from "./SeedingCatching.vue?vue&type=template&id=22234b68&scoped=true"
import script from "./SeedingCatching.vue?vue&type=script&lang=js"
export * from "./SeedingCatching.vue?vue&type=script&lang=js"
import style0 from "./SeedingCatching.vue?vue&type=style&index=0&id=22234b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22234b68",
  null
  
)

export default component.exports